import React from 'react';
import { Flex, Box } from 'rebass';
import Fuse from 'fuse.js';
import EventCard from '../Card';
import Text from '../../Text';

const EventListMapper = ({ events, filter }) => {
  const fuse = new Fuse(events, {
    threshold: 0.33,
    keys: ['venue_name', 'country', 'city', 'state'],
  });
  const filteredEvents = filter.length ? fuse.search(filter) : events;
  return (
    <Flex flexDirection="column" m={-3} py={3}>
      {filteredEvents.length === 0 && (
        <Text textAlign="center" my={5} variant="tertiary" fontSize={3}>
          There are no events here
        </Text>
      )}
      {filteredEvents.map(event => {
        return (
          <Box key={event.id} p={3}>
            <EventCard {...event} />
          </Box>
        );
      })}
    </Flex>
  );
};

EventListMapper.propTypes = {};

export default EventListMapper;
